import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/API/api.service';
import * as $ from 'jquery';
import * as CryptoJS from 'crypto-js';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrls: ['./home-one.component.scss']
})
export class HomeOneComponent implements OnInit {
  ads: any
  categories: any
  offers: any
  cities: any
  vendors: any

  constructor(private api: ApiService,private encrypt: EncryptionService) {}

  ngOnInit(): void {
    this.api.ads().subscribe({
      next: (res: any) => {
        this.ads = res.data
        setTimeout(() => {
          for(let i = 0; i < this.ads.length; i++){
            // console.log(this.ads[i])
            $('.item-bg'+(i+1)).css('background-image', 'url(' + this.ads[i].image + ')')
          }
        }, 100);
      },error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })

    this.api.categories().subscribe({
      next: (response: any) => {
        this.categories = response.data
        this.categories.map((category: any) => {
          // Store the hashed category ID on the category object
          // category.hashedId = this.generateHash(category.id.toString());
          // console.log(category)
        });
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
    
    

    this.api.offers().subscribe({
      next: (response: any) => {
        this.offers = response.data.data
        // console.log(this .offers)
      }, error : (error: HttpErrorResponse) => {}
    })
    
    this.api.countries().subscribe({
      next: (response: any) => {
        this.cities = response.data[0].cities
        // console.log(this .cities[0].cities)
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })

    const pageNumber = 1
    const formData = new FormData()
    formData.append('type', 'vendors')
    this.api.allVendors(formData).subscribe({
      next: (response: any) => {
        this.vendors = response.data.data
        // console.log(this.vendors)
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }

  trackById(item: any): number {
    return item.id;
  }

  generateHash(id: string): string {
    // console.log(id)
    // return CryptoJS.HmacSHA256(id, '123').toString(CryptoJS.enc.Hex);
    return this.encrypt.encryptionAES(id)
  }

}
